import { render, staticRenderFns } from "./ProductComboModal.vue?vue&type=template&id=50453754"
import script from "./ProductComboModal.vue?vue&type=script&lang=js"
export * from "./ProductComboModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports